import axios from 'axios';
import { todoStatuses } from '@utilities/variables';

const BASE = '/api/client-portal';

/**
 * Status vocabulary is shared with the staff side (offen / wartend / erledigt) —
 * same values, same icons, so the two worlds stay readable to whoever supports both.
 */
export const TODO_STATUSES = todoStatuses;

/**
 * Predefined task names (Todo::$portalNameList). "Stornotermin" is the only task the
 * dashboard shows as the trip's deadline — keep it in sync with
 * Todo::PORTAL_NAME_CANCELLATION.
 */
export const PORTAL_TODO_NAMES = ['Stornotermin'];

/**
 * Todos of the caller's client. Deliberately NOT cached: the list changes on every
 * edit, and a stale rail is worse than an extra request.
 *
 * @param {Object} params orderId, status (csv), assignee ('me'|'unassigned'|id),
 *                        dueBefore, _page, _itemsPerPage
 */
export const fetchTodos = function (params = {}) {
    return axios
        .get(`${BASE}/todos`, { params })
        .then((response) => ({
            items: (response.data && response.data.items) || [],
            total: (response.data && response.data.total) || 0,
        }));
};

export const createTodo = function (payload) {
    return axios.post(`${BASE}/todos`, payload).then((response) => response.data);
};

export const updateTodo = function (id, payload) {
    return axios.put(`${BASE}/todos/${id}`, payload).then((response) => response.data);
};

export const deleteTodo = function (id) {
    return axios.delete(`${BASE}/todos/${id}`);
};

// The logged-in portal user. Session-stable, so promise-cached — the assignee
// picker needs it for "nur ich".
let mePromise = null;

export const fetchMe = function () {
    if (!mePromise) {
        mePromise = axios
            .get(`${BASE}/me`)
            .then((response) => response.data)
            .catch((error) => {
                mePromise = null;
                throw error;
            });
    }
    return mePromise;
};

// The client's active portal logins — stable for a session, so promise-cached like
// fetchFieldDefinitions.
let portalUsersPromise = null;

export const fetchPortalUsers = function () {
    if (!portalUsersPromise) {
        portalUsersPromise = axios
            .get(`${BASE}/portal-users`)
            .then((response) => response.data || [])
            .catch((error) => {
                portalUsersPromise = null;
                throw error;
            });
    }
    return portalUsersPromise;
};

/**
 * Upsert the deadline of a Leistung. Resolves with the item in the same shape the
 * day endpoints return, so the route page can merge it through its existing
 * onFreeTextSaved(). Passing null clears the date and closes the task.
 */
export const saveFreeTextDeadline = function (freeTextId, dueDate) {
    return axios
        .put(`${BASE}/free-texts/${freeTextId}/deadline`, { dueDate: dueDate || null })
        .then((response) => response.data);
};
